import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {IUserStore} from "data/stores/user/user.store";
import {makeAutoObservable} from "mobx";
import type {IModalsStore} from "data/stores/modals/modals.store";

export interface IHOCMainController extends ViewController {
	get isLoadingUser(): boolean;
}

@injectable()
export class HOCMainController implements IHOCMainController {
	constructor(
		@inject(Bindings.UserStore) private _userStore: IUserStore,
		@inject(Bindings.ModalsStore) private _modalsStore: IModalsStore
	) {
		makeAutoObservable(this);
	}
	dispose(): void {
		return;
	}

	init(param: void): void {
		this.fetchUser();
	}

	private fetchUser(): void {
		void this._userStore.fetchUser().finally(() => {
			if (this._userStore.user) {
				void this._userStore.fetchUserProfile().finally(() => {
					if (this._userStore.profile && !this._userStore.profile.terms) {
						this._modalsStore.showTerms();
					}
				});
			}
		});
	}

	get isLoadingUser(): boolean {
		return this._userStore.isRequestingUser;
	}
}
